import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["color", "size"];
import React from 'react';
import { intrinsicComponent } from './utils/functions';
export var Annotate = intrinsicComponent(function (_ref, ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 14 : _ref$size,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    ref: ref,
    width: size,
    height: size,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, rest), /*#__PURE__*/React.createElement("path", {
    d: "M46.1442 31.3785C45.4585 31.3785 44.8974 31.9424 44.8974 32.6316V43.7344C44.8974 45.802 43.2267 47.4812 41.157 47.4938H6.22156C4.16433 47.4938 2.49361 45.8146 2.48114 43.7344V11.1278C2.48114 9.06018 4.15186 7.38098 6.22156 7.36845H17.2807C17.9665 7.36845 18.5275 6.80454 18.5275 6.11532C18.5275 5.42609 17.9665 4.86218 17.2807 4.86218H6.22156C2.79284 4.87471 0 7.6692 0 11.1278V43.7344C0 47.193 2.79284 50 6.22156 50H41.157C44.5982 50 47.3786 47.193 47.3786 43.7469V32.6316C47.391 31.9424 46.83 31.3785 46.1442 31.3785Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.8923 1.65414C44.698 -0.551378 41.157 -0.551378 38.9627 1.65414L16.7571 23.9724C16.6075 24.1228 16.4953 24.3108 16.4329 24.5238L13.5154 35.1253C13.3907 35.5639 13.5154 36.0276 13.8396 36.3409C14.1513 36.6541 14.6251 36.7794 15.049 36.6667L25.5969 33.7343C25.8089 33.6717 25.9959 33.5714 26.1455 33.4085L48.3636 11.0777C50.5455 8.87218 50.5455 5.31328 48.3636 3.10777L46.8923 1.65414ZM19.4751 24.787L37.6535 6.51629L43.5135 12.406L25.3351 30.6892L19.4751 24.787ZM18.3031 27.1554L22.9911 31.8672L16.5077 33.6717L18.3031 27.1554ZM46.5931 9.31078L45.2715 10.6391L39.4115 4.74937L40.7331 3.42105C41.9425 2.20551 43.9249 2.20551 45.1343 3.42105L46.5931 4.88722C47.815 6.11529 47.815 8.09524 46.5931 9.31078Z",
    fill: color
  }));
});
export default Annotate;